import { Plugin } from '@ckeditor/ckeditor5-core';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget';
import InsertCompareResumesCommand from './compare-resumes-command';
import { Widget } from '@ckeditor/ckeditor5-widget';
export default class CompareResumesEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertCompareResumes', new InsertCompareResumesCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('compareResumes', {
            isObject: true,
            allowWhere: '$block',
        });
        schema.register('compareResumesCaption', {
            isLimit: true,
            allowIn: 'compareResumes',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        // <compareResumes> converters
        conversion.for('upcast').elementToElement({
            model: 'compareResumes',
            view: 'x-compare-resumes',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'compareResumes',
            view: 'x-compare-resumes',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'compareResumes',
            view: (model, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class: 'compare-resumes',
                });
                return toWidget(div, writer, { label: 'compare resumes widget' });
            },
        });
        // <compareResumesCaption> converters
        conversion.for('upcast').elementToElement({
            model: 'compareResumesCaption',
            view: 'x-compare-resumes-caption',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'compareResumesCaption',
            view: 'x-compare-resumes-caption',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'compareResumesCaption',
            view: (model, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'compare-resumes__caption',
                });
                return toWidgetEditable(div, writer);
            },
        });
    }
}
